<div class="portalnav-wrap por-ac-invoices">
    <div class="portalnav wrapper" [ngStyle]="{ height: height, width: width }" class="wrapper">
        <div class="wrapper heading-section">
            @if (appFacadeService.getCustomer() | async; as customer) {
            <h1 class="theme-heading">{{ 'InvoicesListFor' | translate | uppercase }} {{ customer?.Name }}</h1>
            }
        </div>
        <div id="mainportalpage" class="main-invoice-page">
            @if (appFacadeService.getSubActiveTab() | async; as tab) {
            <div [hidden]="tab !== 'Default'">
                <ng-container [ngTemplateOutlet]="invoices"></ng-container>
            </div>
            <div [hidden]="tab !== 'InvoiceDetail'">
                <ng-container [ngTemplateOutlet]="invoiceDetail"></ng-container>
            </div>
            }
        </div>
    </div>
</div>
<ng-template #invoices>
    <div class="date-range">
        <por-filters
            [initFilters]="initialStatusFilters"
            [isProcessing]="(appFacadeService.getLoader() | async) || false"
            [searchPlaceholder]="filterComponentProps.searchPlaceHolder"
            [dateLabel]="filterComponentProps.dateLabel"
            (filterOutput)="filter($any($event))"
            (exportCSV)="exportCSV()"
            [uiUrl]="uiUrl"
            [enableExport]="$any(invoices$ | async | count) > 0"
            [startDateLabel]="'InvoiceStartDateLabel'"
            [endDateLabel]="'End Date'"></por-filters>
    </div>
    <div class="content-wrapper">
        @if (invoiceTotalAmountDue$ | async; as invoiceTotalAmountDue) {
        <div class="amount-due-wrap">
            <span>{{ 'TotalDue' | translate }} : {{ invoiceTotalAmountDue | formatCurrency }}</span>
        </div>
        } @if (gridReadyObservable$ | async) {
        <ag-grid-angular
            style="width: 100%; height: 100%"
            class="ag-theme-alpine ag-grid"
            [columnDefs]="columnDefs"
            [defaultColDef]="defaultColDef"
            [rowData]="invoices$ | async"
            [animateRows]="true"
            [rowHeight]="rowHeight"
            [headerHeight]="headerHeight"
            (gridReady)="onGridReady($event)"
            [isFullWidthRow]="isFullWidthRow"
            [fullWidthCellRenderer]="fullWidthCellRenderer"
            [context]="context"
            [suppressRowClickSelection]="true"></ag-grid-angular>
        }
    </div>
    <div class="middle">
        <por-load-more [hasMoreRecord]="(noMoreRecord$ | async) ?? false" [featureName]="'load-more-invoice'" (loadMore)="loadMore()"></por-load-more>
    </div>
    @if (appFacadeService.isDialogDisplayed() | async) {
    <por-app-confirm-dialog [message]="''" [dialogType]="dialogType" (confirmed)="appFacadeService.toggleDialog(false)">
        <p>{{ 'InvoiceFailedToLoad' | translate }}</p>
    </por-app-confirm-dialog>
    }
</ng-template>
<ng-template #invoiceDetail>
    @if (appFacadeService.getInvoiceDetail() | async; as invoiceDetail) {
    <div class="contract-details-page">
        @if (invoiceDetail) {
        <por-invoice-detail [invoiceDetail]="invoiceDetail" [uiUrl]="uiUrl" (closePanel)="closeInvoiceDetail()"></por-invoice-detail>
        }
    </div>
    }
</ng-template>
